export default {
  // getExceptionLogsList
  START_GET_EXCEPTION_LOGS: 'START_GET_EXCEPTION_LOGS',
  GET_EXCEPTION_LOGS_SUCCESS: 'GET_EXCEPTION_LOGS_SUCCESS',
  GET_EXCEPTION_LOGS_FAILED: 'GET_EXCEPTION_LOGS_FAILED',
  // getAllExceptionTypes
  START_GET_ALL_EXCEPTION_TYPES: 'START_GET_ALL_EXCEPTION_TYPES',
  GET_ALL_EXCEPTION_TYPES_SUCCESS: 'GET_ALL_EXCEPTION_TYPES_SUCCESS',
  GET_ALL_EXCEPTION_TYPES_FAILED: 'GET_ALL_EXCEPTION_TYPES_FAILED',
}
